<mat-slide-toggle
  [color]="'primary'"
  [labelPosition]="labelPosition"
  [appTheme]="'THEME_SYSTEM_SUCCESS'"
  [formControl]="$any(ngControl.control)"
  (change)="onChange($event)"
  [matTooltip]="!label&&tooltip ? tooltip : null"
  >
  <mat-label *ngIf="!!label"
    [matTooltip]="!hideTooltip ? label : ''">
    {{ label }}
    <app-bui-tooltip-icon *ngIf="tooltip"
      [tooltip]="tooltip">
    </app-bui-tooltip-icon>
  </mat-label>
</mat-slide-toggle>
